module.exports = __webpack_public_path__ + "img/contraceptive-pill_x2.7ef7e778.png";